import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MobileSdkTestSeveritiesQueryVariables } from '../MobileSdkTestSeverities.generated';

export const buildMobileSdkTestSeveritiesQueryVariables = (
	testId: string
): MobileSdkTestSeveritiesQueryVariables => ({
	runId: buildRunIdParam(testId).runId
});
